export default __webpack_public_path__ + "static/media/8C.e91af699.svg";